import { useApiQuery } from './useApiQuery';

interface PollingLocation {
  address: {
    addressLine: string[];
    city: string;
    line1: string;
    line2: string | null;
    locationName: string;
    state: string;
    zip: string;
  };
  latitude: number;
  longitude: number;
  pollingHours: string;
  sources: Array<{
    name: string;
    official: boolean;
  }>;
}

interface PollingLocationsResponse {
  success: boolean;
  message: string;
  data: {
    contests: any[];
    dropOffLocations: any[];
    election: {
      electionDay: string;
      id: string;
      name: string;
      ocdDivisionId: string;
    };
    normalizedInput: {
      city: string;
      line1: string;
      state: string;
      zip: string;
    };
    pollingLocations: PollingLocation[];
    state: any[];
  };
}

interface UsePollingLocationsProps {
  address: string;
  city: string;
  state: string;
  zipcode: string;
  headers?: Record<string, string>;
  enabled?: boolean;
}

export function usePollingLocations({
  address,
  city,
  state,
  zipcode,
  headers,
  enabled = true,
}: UsePollingLocationsProps) {
  return useApiQuery<PollingLocationsResponse>({
    queryKey: ['polling-locations', { address, city, state, zipcode }],
    request: {
      url: `/polling-locations/lookup`,
      method: 'GET',
      headers,
      params: {
        street: address,
        city,
        state,
        zip: zipcode,
      },
    },
    enabled: enabled && !!(address && city && state && zipcode),
  });
}
